const OneSignal = window.OneSignal || [];

const initialConfigNotification = () =>{
    
    OneSignal.push(()=>{
        OneSignal.init({
            appId:"532f17b3-a252-48b4-901e-175ee57ca8df",
            autoRegister: false,
            notifyButton: {
                nable: true,
            },
            allowLocalhostAsSecureOrigin: true,
        });
    })
}

export default{
    initialConfigNotification
}




// WEBPACK FOOTER //
// ./src/serviceWorker.js